export const INTERCEPTOR_SKIP_CONSTANT = {
  AUTHENTICATION: 'authentication-interceptor-skip',
  ERRORS: 'errors-interceptor-skip',
  LANGUAGE: 'language-interceptor-skip',
  REQUEST_COUNT: 'request-count-interceptor-skip',
};
